module.exports = __webpack_public_path__ + "img/oval.afd51376.png";